// Just a global backed by local storage.

let imposeCount: null | number = null;
const key = "ImposeCount";
const minimum = 679822;  // Observed 2024-11-09.

export function getImposeCount(): number {
    if (null === imposeCount) {
        const n = Number(window.localStorage.getItem(key));
        imposeCount = n > minimum ? n : minimum;
    }
    return imposeCount;
}

export function storeImposeCount(n: number) {
    if (null === imposeCount || n > imposeCount) {
        imposeCount = n;
        window.localStorage.setItem(key, String(n));
    }
}